 
 <input type="text" spellcheck="false"   class="form-control m-3" #answerInput name="answerInput" autofocus
 [placeholder]="language.typeInYourAnswer" *ngIf="issaq" required (change)="onAnswerChange()" 
 (input)="onAnswerInputChange()" (keydown)="preventPipe($event)" 
 [attr.aria-label]="language.typeInYourAnswer"/>